/**
 * Reusable Picture component with WebP + fallback.
 * - `webpSrc`: path to the .webp image (preferred)
 * - `fallbackSrc`: original .png/.jpg used if browser doesn't support WebP
 * - all other props (className, alt, width, height, loading, ...) forwarded to <img>
 *
 * Usage:
 *   import logoWebp from "../assets/tamari-logo.webp";
 *   import logoPng from "../assets/tamari-logo.png";
 *   <Picture webpSrc={logoWebp} fallbackSrc={logoPng} alt="Tamari" className="h-12 w-auto" />
 */
const Picture = ({ webpSrc, fallbackSrc, alt = "", className = "", loading = "lazy", width, height, ...rest }) => (
  <picture>
    <source srcSet={webpSrc} type="image/webp" />
    <img
      src={fallbackSrc}
      alt={alt}
      className={className}
      loading={loading}
      width={width}
      height={height}
      {...rest}
    />
  </picture>
);

export default Picture;
